<div (click)="toggleOverlay()"
     (focus)="toggleOverlay()"
     class="kal-select__trigger">

  <div>

    <ng-container *ngIf="selection?.length > 0; else placeHolderTemplate">

      <div class="kal-select__triggervalue">

        <ng-container
          *ngTemplateOutlet="triggerValue ? triggerValueTemplate : kalSelectPlaceholder?.view; context: {selection: selection}">
        </ng-container>

        <ng-template #triggerValueTemplate>
          {{ triggerValue }}
        </ng-template>

      </div>

    </ng-container>

    <ng-template #placeHolderTemplate>
      <div class="kal-select__placeholder">{{ placeholder }}</div>
    </ng-template>
    <kal-icon>keyboard_arrow_down</kal-icon>

  </div>

</div>

<ng-template #optionsPortal="cdkPortal" cdkPortal>
  <div [class]="overlayClassList"
       [kalTheme]="theme">
    <div class="kal-select__searchbar"
         *ngIf="displaySearchbar">
      <kal-input [formControl]="searchbarFormControl"
                 [kalTheme]="theme"
                 icon="search"
                 [placeholder]="searchbarPlaceholder">
      </kal-input>
    </div>
    <ng-content></ng-content>
  </div>
</ng-template>
